<div class="title-wrapper">
  <h1>
    {{ ruleName | titlecase }}
  </h1>
  @if(categories){
  <p>{{categories.name | titlecase}}</p>
  }@else {
  <p>{{"Discover"|translate:{category: ruleName} | titlecase }}</p>
  }
</div>

@if(categories){
<div class="categories-wrapper">

  @for(category of categories.childs; track $index){
  <div class="category">
    <a class="btn btn-light btn-rounded" [routerLink]="rulesService.getCategoryPageUrl(category)">
      <app-asset [assetId]="category.assetId"></app-asset>
    </a>
    <div class="name">
      {{category.name.toUpperCase()}}
    </div>
  </div>
  }

</div>
}
